import {CdkMenu, CdkMenuItem, CdkMenuTrigger} from '@angular/cdk/menu';
import {ChangeDetectionStrategy, Component, inject, output, ViewEncapsulation} from '@angular/core';
import {TranslocoDirective, TranslocoService} from '@jsverse/transloco';
import {Dispatcher} from '@ngrx/signals/events';
import {DefaultAvatarComponent, MediaPreviewComponent} from '@scalified-monorepo/ng-shared';
import {AuthEvents, AuthStore} from '@scalified-monorepo/ng-shared/auth';

@Component({
  selector: 'admin-navbar',
  imports: [TranslocoDirective, CdkMenu, CdkMenuItem, CdkMenuTrigger, MediaPreviewComponent, DefaultAvatarComponent],
  templateUrl: './admin-navbar.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminNavbarComponent {
  sidebarToggle = output<void>();
  private dispatcher = inject(Dispatcher);
  private authStore = inject(AuthStore);
  private translocoService = inject(TranslocoService);

  currentLanguage = this.translocoService.getActiveLang();

  supervisedIdentity = this.authStore.supervisedIdentity;
  identity = this.authStore.identity;
  activeAccount = this.authStore.activeAccount;

  openSite() {
    window.open(
      `${this.currentLanguage && this.currentLanguage !== 'en' ? `/${this.currentLanguage}/` : '/'}`,
      '_blank'
    );
  }

  logout() {
    this.dispatcher.dispatch(AuthEvents.Logout({}));
  }
}
